import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { MermaidAddon } from './MermaidAddon';

/**
 * Draws ```mermaid blocks in TechDocs pages. The generator does not: mkdocs
 * leaves them as `<pre class="mermaid">` (a superfences custom fence, set in
 * the documented repository's mkdocs.yml), and this addon renders each one in
 * the browser — nothing changes on the backend or in the image.
 */
const techDocsMermaidAddon = AddonBlueprint.make({
  name: 'mermaid',
  params: {
    name: 'Mermaid',
    location: TechDocsAddonLocations.Content,
    component: MermaidAddon,
  },
});

export const techdocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techDocsMermaidAddon],
});
